import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'


const _hoisted_1 = { class: "genericPadding hasHeader hasFooter bgWhite" }
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between py-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "fs_12 greyBlue" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "sideContainer" }, null, -1)
const _hoisted_6 = { class: "fs_13 greyBlue text-uppercase d-block mb-2" }
const _hoisted_7 = { class: "fs_13 greyBlue text-uppercase d-block mb-2 mt-4" }
const _hoisted_8 = { class: "footerButtonContainer" }
const _hoisted_9 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "sideContainer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _hoisted_3
      ]),
      _createVNode("span", _hoisted_4, _toDisplayString(_ctx.title), 1),
      _hoisted_5
    ]),
    _createVNode("span", _hoisted_6, _toDisplayString(_ctx.infoLabel), 1),
    _withDirectives(_createVNode("select", {
      class: "genericInput squareInput",
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.permissions.info = $event))
    }, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.groups, (item, i) => {
        return (_openBlock(), _createBlock("option", {
          key: i,
          value: item
        }, _toDisplayString(item), 9, ["value"]))
      }), 128))
    ], 512), [
      [_vModelSelect, _ctx.permissions.info]
    ]),
    _createVNode("span", _hoisted_7, _toDisplayString(_ctx.contentLabel), 1),
    _withDirectives(_createVNode("select", {
      class: "genericInput squareInput",
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.permissions.content = $event))
    }, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.groups, (item, i) => {
        return (_openBlock(), _createBlock("option", {
          key: i,
          value: item
        }, _toDisplayString(item), 9, ["value"]))
      }), 128))
    ], 512), [
      [_vModelSelect, _ctx.permissions.content]
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode("div", _hoisted_9, [
        _createVNode("button", {
          type: "button",
          class: "genericButton bgWhite w-100 me-1",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
        }, [
          _createVNode(_component_localized_text, {
            class: "fs_14 spaceCadet",
            localizedKey: "app_annulla",
            text: "Annulla"
          })
        ]),
        _createVNode("button", {
          type: "button",
          class: "genericButton bgGreyBlue w-100 ms-1",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.save()))
        }, [
          _createVNode(_component_localized_text, {
            class: "fs_14 white",
            localizedKey: "app_conferma",
            text: "Conferma"
          })
        ])
      ])
    ])
  ]))
}